import { render, staticRenderFns } from "./filterMenu.vue?vue&type=template&id=480d4b5f&"
import script from "./filterMenu.vue?vue&type=script&lang=js&"
export * from "./filterMenu.vue?vue&type=script&lang=js&"
import style0 from "./filterMenu.vue?vue&type=style&index=0&id=480d4b5f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports